import axios from 'axios';

export const getUsersList = async (setUsers: (value: { id: string; label: string }[]) => void) => {
    try {
        const response = await axios.get('/users/list');
        const userData: { id: string; label: string }[] = [];
        for (const [key, value] of Object.entries(response.data.users)) {
            userData.push({ id: key, label: value as string });
        }
        setUsers(userData);
    } catch (err) {
        console.error(`error in users map -key-value-  ${err}`);
    }
};

export const getRolesList = async (setRoles: (value: { id: string; label: string }[]) => void) => {
    try {
        const response = await axios.get('/users/roles/list');
        const rolesData: { id: string; label: string }[] = [];
        for (const [key, value] of Object.entries(response.data.roles)) {
            rolesData.push({ id: key, label: value as string });
        }
        setRoles(rolesData);
    } catch (err) {
        console.error(`error in roles list -key-value-  ${err}`);
    }
};

export const getPermissionsList = async (setPermissions: (value: { id: number; name: string; icon: string }[]) => void) => {
    try {
        const response = await axios.get('/module-permissions/list');
        setPermissions(response.data.module_permissions);
    } catch (err) {
        console.error(`Error getting permissions list ${err}`);
    }
};
export default getUsersList;
